import zhHant from 'vuetify/lib/locale/zh-Hant'

// Usage -> {{ t('$vuetify.close') }} -> 关闭
export default {
  ...zhHant,
  __InterfaceSetting: {
    bottom_menu: {
      title: '底部選單',
      add_item: '新增項目',
      delete_item: '刪除項目',
      change_image: '更換圖片',
      payload: '觸發文字'
    },
    weather: {
      title: '天氣',
      select_region: '選擇地區',
      hint: '選擇裝置上要顯示哪個地區的天氣。',
      hong_kong: '香港',
      taiwan: '台灣'
    },
    branding: {
      title: '品牌圖片',
      description: '自訂裝置上顯示的背景、標誌及 QR Code 圖片。',
      background: '背景',
      logo: '標誌',
      qr: 'QR Code',
      hint: '支援格式：PNG、JPG、WEBP，檔案上限 8MB。',
      using_default: '使用預設圖片',
      upload: '上載',
      change: '更換',
      reset: '還原預設',
      done: '完成',
      cancel: '取消',
      upload_file: '上載檔案',
      filepond_hint: '拖放圖片至此或瀏覽…'
    }
  },
  __AI: {
    mrc: {
      sources: '來源',
      sources_desc: '上載並管理供 MRC AI 掃描的文件與網站。',
      upload_document: '上載文件',
      add_website: '新增網站',
      search_sources: '搜尋來源',
      type_document: '文件',
      type_website: '網站',
      status_crawled: '已擷取',
      upload_to_other_lang_hint: '已上載至 {0}。',
      waiting_response: '等待回應中…',
      query_timeout: '請求逾時，請重試。',
      export: {
        button: '匯出文件清單',
        device_name: '裝置名稱',
        enabled: '已啟用',
        disabled: '已停用'
      },
      upload_file_dialog: {
        title: '上載文件'
      },
      add_website_dialog: {
        title: '新增網站',
        url_label: '網站網址',
        url_placeholder: 'https://example.com/...',
        invalid_url: '請輸入有效的網址'
      },
      batch: {
        selected: '已選取 {0} 項',
        delete: '刪除',
        enable: '啟用',
        disable: '停用',
        clear: '清除選取',
        confirm_delete_title: '刪除 {0} 份文件？',
        confirm_delete_hint: '所選文件將被永久刪除，且無法復原。',
        confirm_enable_title: '啟用 {0} 份文件？',
        confirm_enable_hint: '所選文件將被啟用，納入 MRC AI 掃描。',
        confirm_disable_title: '停用 {0} 份文件？',
        confirm_disable_hint: '所選文件將被排除於 MRC AI 掃描之外。',
        success_delete: '已排入刪除 {0} 份文件。',
        success_enable: '已啟用 {0} 份文件。',
        success_disable: '已停用 {0} 份文件。',
        partial: '成功 {0} 項，失敗 {1} 項。',
        too_many: '一次最多只能處理 {0} 份文件。'
      }
    }
  },
  __DatatableHeader: {
    file_name_or_source: '檔案名稱 / 來源',
    type: '類型',
    enable: '啟用'
  },
  __Dashboard: {
    funnel_title: 'Botisfy 使用漏斗',
    funnel_proxy_note: '* 代理值（精確數據待事件追蹤上線）',
    funnel_error: '漏斗載入失敗',
    opened_sessions: '開啟人次',
    engaged_sessions: '互動人次',
    answered_turns: '回答輪次',
    avg_turns_per_engaged_session: '平均互動輪次',
    opened_sessions_tooltip: '使用者開啟 chatbot 或建立 session 的次數，可能包含只看到歡迎語、語言選擇或 disclaimer，但尚未實際發問的情況。',
    engaged_sessions_tooltip: '至少有一次實際互動的 session，例如選擇語言、接受 disclaimer、點擊按鈕或輸入訊息。',
    answered_turns_tooltip: 'Bot 實際回覆使用者問題的輪次。一般來說，一次使用者提問加一次 bot 回答，計為一個回答輪次。',
    avg_turns_per_engaged_session_tooltip: '平均每個有互動的 session 產生多少輪有效問答，可用來觀察使用者是否持續與 chatbot 對話。'
  },
  __LeftBar: {
    search_device: '搜尋裝置',
    no_device_found: '找不到相符的裝置'
  }
}
